import React from "react";
import ContentLoader from "react-content-loader";

const PoolItemWideLoaderLarge = (props) => (
    <ContentLoader 
    speed={2}
    width={792}
    height={620}
    viewBox="0 0 792 620"
    backgroundColor="#c0cdd8"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="229" y="29" rx="0" ry="0" width="18" height="0" /> 
    <rect x="284" y="49" rx="0" ry="0" width="1" height="2" /> 
    <rect x="3" y="2" rx="0" ry="0" width="409" height="42" /> 
    <rect x="1" y="63" rx="0" ry="0" width="633" height="26" /> 
    <rect x="12" y="101" rx="0" ry="0" width="57" height="14" /> 
    <rect x="96" y="100" rx="0" ry="0" width="113" height="14" /> 
    <rect x="347" y="102" rx="0" ry="0" width="8" height="9" /> 
    <rect x="493" y="97" rx="0" ry="0" width="113" height="14" /> 
    <rect x="10" y="130" rx="0" ry="0" width="36" height="12" /> 
    <rect x="8" y="177" rx="0" ry="0" width="36" height="12" /> 
    <rect x="7" y="233" rx="0" ry="0" width="36" height="12" /> 
    <rect x="9" y="286" rx="0" ry="0" width="36" height="12" /> 
    <rect x="8" y="342" rx="0" ry="0" width="36" height="12" /> 
    <rect x="8" y="403" rx="0" ry="0" width="36" height="12" /> 
    <rect x="7" y="448" rx="0" ry="0" width="36" height="12" /> 
    <rect x="6" y="499" rx="0" ry="0" width="36" height="12" /> 
    <rect x="6" y="556" rx="0" ry="0" width="36" height="12" /> 
    <rect x="96" y="130" rx="0" ry="0" width="158" height="21" /> 
    <rect x="444" y="125" rx="0" ry="0" width="158" height="21" /> 
    <rect x="97" y="234" rx="0" ry="0" width="158" height="21" /> 
    <rect x="95" y="286" rx="0" ry="0" width="158" height="21" /> 
    <rect x="97" y="343" rx="0" ry="0" width="158" height="21" /> 
    <rect x="98" y="400" rx="0" ry="0" width="158" height="21" /> 
    <rect x="98" y="448" rx="0" ry="0" width="158" height="21" /> 
    <rect x="100" y="500" rx="0" ry="0" width="158" height="21" /> 
    <rect x="98" y="559" rx="0" ry="0" width="158" height="21" /> 
    <rect x="95" y="178" rx="0" ry="0" width="158" height="21" /> 
    <rect x="442" y="177" rx="0" ry="0" width="158" height="21" /> 
    <rect x="440" y="237" rx="0" ry="0" width="158" height="21" /> 
    <rect x="441" y="288" rx="0" ry="0" width="158" height="21" /> 
    <rect x="439" y="343" rx="0" ry="0" width="158" height="21" /> 
    <rect x="442" y="403" rx="0" ry="0" width="158" height="21" /> 
    <rect x="440" y="448" rx="0" ry="0" width="158" height="21" /> 
    <rect x="438" y="502" rx="0" ry="0" width="158" height="21" /> 
    <rect x="436" y="557" rx="0" ry="0" width="158" height="21" />
  </ContentLoader>
);

export default PoolItemWideLoaderLarge;
